import React from "react";
import { useSelector } from "react-redux";
import CartBillDetails from "./CartBillDetails";
import CartItem from "./CartItem";

export default function Cart() {
  const { products, totalQuntity } = useSelector((state) => state.product);
  return (
    <>
      <div className="container 2xl:px-8 px-2 mx-auto">
        <h2 className="mb-8 text-xl font-bold">Shopping Cart</h2>
        <div className="cartListContainer">
          <CartItem
            products={products.filter(
              (product) => product?.totalSelectQuntity > 0
            )}
          />
          <CartBillDetails />
        </div>
      </div>
    </>
  );
}
